<script>
	// Use $props() to receive data from the parent
	export let position;
</script>

<!-- <div class="fatality-risk">Increased risk of fatality</div> -->
<div class="fatality-risk {position}">!</div>